import React from "react";
import { Col, Row, Typography } from "antd";
import { TitleCase } from "@/utils/string";

import ScoreCard from "./ScoreCard";
import { useBenchmarkContext } from "../hook";

export default () => {
  const { selectedKey } = useBenchmarkContext();

  return (
    <div>
      {/* Title*/}
      <Row>
        {selectedKey.map(e => (
          <Col key={e} span={24 / selectedKey.length}>
            <Typography.Title level={4} underline>
              {TitleCase(e)}
            </Typography.Title>
          </Col>
        ))}
      </Row>

      {/* Card contents*/}
      <div style={{ overflowY: "scroll", maxHeight: window.innerHeight - 200 }}>
        <Row gutter={[16, 16]}>
          {selectedKey.map(e => (
            <Col key={e} span={24 / selectedKey.length}>
              <ScoreCard investmentStyle={e} />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};
